module.exports = __webpack_public_path__ + "static/media/di9h5x7chs1.a53bb63d.jpg";